import { render, staticRenderFns } from "./ReviewTeamAssignmentTable.vue?vue&type=template&id=2f4c8471&"
import script from "./ReviewTeamAssignmentTable.vue?vue&type=script&lang=js&"
export * from "./ReviewTeamAssignmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports